import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { MetingInhoud, MetingStatus, fmtDatum, openMetingPdf } from '../components/MetingenLijst';

export default function MetingenInbox() {
  const navigate = useNavigate();
  const [tab, setTab] = useState('verstuurd');
  const [ongekoppeld, setOngekoppeld] = useState(false);
  const [lijst, setLijst] = useState([]);
  const [openTeller, setOpenTeller] = useState(0);
  const [laden, setLaden] = useState(true);
  const [zoek, setZoek] = useState('');
  const [gekozen, setGekozen] = useState(null);
  const [projecten, setProjecten] = useState([]);

  const laad = useCallback(async () => {
    setLaden(true);
    try {
      const r = await api.get('/metingen/inbox', { params: { status: tab === 'alle' ? undefined : tab, ongekoppeld: ongekoppeld ? '1' : undefined } });
      setLijst(r.data.inzendingen || []);
      setOpenTeller(r.data.open || 0);
    } catch (e) { setLijst([]); }
    finally { setLaden(false); }
  }, [tab, ongekoppeld]);

  useEffect(() => { laad(); }, [laad]);
  useEffect(() => {
    api.get('/projecten').then(r => setProjecten((r.data.projecten || []).filter(p => p.status !== 'afgerond'))).catch(() => {});
  }, []);

  const q = zoek.trim().toLowerCase();
  const gefilterd = !q ? lijst : lijst.filter(m =>
    [m.template_naam, m.monteur_naam, m.ordernummer, m.werkorder_titel, m.project_naam, m.locatie_adres]
      .some(x => (x || '').toLowerCase().includes(q)));

  return (
    <div style={{ padding: 24, maxWidth: 1200, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16, flexWrap: 'wrap' }}>
        <h2 style={{ margin: 0 }}>📐 Metingen binnen</h2>
        {openTeller > 0 && <span style={{ background: '#2563eb', color: '#fff', borderRadius: 999, padding: '2px 10px', fontSize: 13, fontWeight: 700 }}>{openTeller} nieuw</span>}
        <div style={{ flex: 1 }} />
        <input value={zoek} onChange={e => setZoek(e.target.value)} placeholder="Zoek formulier, monteur, order, project…"
          style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #d1d5db', width: 280 }} />
        <button onClick={() => navigate('/templates')} style={knopSec}>Formulieren beheren</button>
      </div>

      <div style={{ display: 'flex', gap: 6, marginBottom: 14, alignItems: 'center', flexWrap: 'wrap' }}>
        {[['verstuurd', 'Nieuw'], ['verwerkt', 'Verwerkt'], ['alle', 'Alle']].map(([k, t]) => (
          <button key={k} onClick={() => setTab(k)} style={{
            padding: '7px 14px', borderRadius: 8, border: '1px solid ' + (tab === k ? '#2563eb' : '#d1d5db'),
            background: tab === k ? '#2563eb' : '#fff', color: tab === k ? '#fff' : '#374151', cursor: 'pointer', fontWeight: 600
          }}>{t}</button>
        ))}
        <label style={{ marginLeft: 12, fontSize: 14, display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
          <input type="checkbox" checked={ongekoppeld} onChange={e => setOngekoppeld(e.target.checked)} />
          Alleen zonder werkorder/project
        </label>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: gekozen ? 'minmax(320px, 1fr) minmax(420px, 1.3fr)' : '1fr', gap: 16, alignItems: 'start' }}>
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', overflow: 'hidden' }}>
          {laden ? <div style={leeg}>Laden…</div> : gefilterd.length === 0 ? <div style={leeg}>Geen metingen</div> : gefilterd.map(m => (
            <div key={m.id} onClick={() => setGekozen(m.id)} style={{
              padding: '11px 14px', borderBottom: '1px solid #f1f5f9', cursor: 'pointer',
              background: gekozen === m.id ? '#eff6ff' : '#fff', display: 'flex', gap: 10, alignItems: 'center'
            }}>
              <span style={{ fontSize: 20 }}>{m.soort === 'afname' ? '✅' : '📐'}</span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{m.template_naam} <span style={{ color: '#9ca3af', fontWeight: 400 }}>#{m.id}</span></div>
                <div style={{ fontSize: 12, color: '#6b7280', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {m.monteur_naam} · {fmtDatum(m.verstuurd_op)}
                  {m.locatie_adres ? ' · ' + m.locatie_adres : ''}
                </div>
                <div style={{ fontSize: 12, marginTop: 2 }}>
                  {m.ordernummer ? <span style={tag}>🔧 {m.ordernummer}</span> : null}
                  {m.project_naam ? <span style={tag}>📁 {m.project_naam}</span> : null}
                  {!m.ordernummer && !m.project_naam ? <span style={{ ...tag, background: '#fef3c7', color: '#92400e' }}>niet gekoppeld</span> : null}
                </div>
              </div>
              <MetingStatus status={m.status} />
            </div>
          ))}
        </div>

        {gekozen && (
          <Detail key={gekozen} id={gekozen} projecten={projecten}
            onSluit={() => setGekozen(null)} onGewijzigd={laad} navigate={navigate} />
        )}
      </div>
    </div>
  );
}

function Detail({ id, projecten, onSluit, onGewijzigd, navigate }) {
  const [m, setM] = useState(null);
  const [wo, setWo] = useState('');
  const [proj, setProj] = useState('');
  const [opm, setOpm] = useState('');
  const [bezig, setBezig] = useState(false);
  const [melding, setMelding] = useState('');

  const zet = (x) => {
    setM(x); setWo(x.ordernummer || (x.werkorder_id ? String(x.werkorder_id) : ''));
    setProj(x.project_id ? String(x.project_id) : ''); setOpm(x.opmerking_kantoor || '');
  };
  useEffect(() => { api.get(`/metingen/${id}`).then(r => zet(r.data.inzending)).catch(() => setM(false)); }, [id]);

  const koppel = async () => {
    setBezig(true); setMelding('');
    try {
      const body = { werkorder: wo || null };
      // leeg project + werkorder ingevuld → project automatisch van werkorder; expliciet kiezen overschrijft
      if (proj) body.project_id = parseInt(proj, 10);
      else if (!wo) body.project_id = null;
      const r = await api.put(`/metingen/${id}/koppel`, body);
      zet(r.data.inzending);
      setMelding(r.data.inzending.project_id ? '✓ Gekoppeld — PDF staat in het projectmapje' : '✓ Gekoppeld');
      onGewijzigd();
    } catch (e) { setMelding('⚠ ' + (e.response?.data?.message || e.message)); }
    finally { setBezig(false); }
  };

  const verwerk = async (verwerkt) => {
    setBezig(true);
    try {
      const r = await api.put(`/metingen/${id}/verwerkt`, { verwerkt, opmerking: opm });
      zet(r.data.inzending); onGewijzigd();
    } catch (e) { alert(e.response?.data?.message || e.message); }
    finally { setBezig(false); }
  };

  if (m === null) return <div style={paneel}>Laden…</div>;
  if (m === false) return <div style={paneel}>Kon meting niet laden</div>;
  const snap = m.template_snapshot || {};

  return (
    <div style={paneel}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
        <h3 style={{ margin: 0, flex: 1 }}>{snap.naam} <span style={{ color: '#9ca3af', fontWeight: 400, fontSize: 14 }}>#{m.id}</span></h3>
        <MetingStatus status={m.status} />
        <button onClick={() => openMetingPdf(m.id)} style={knopSec}>📄 PDF</button>
        <button onClick={onSluit} style={{ ...knopSec, padding: '6px 10px' }}>✕</button>
      </div>
      <div style={{ fontSize: 13, color: '#4b5563', marginBottom: 12, lineHeight: 1.6 }}>
        {snap.soort === 'afname' ? 'Afnameformulier' : 'Meetformulier'} · <strong>{m.monteur_naam}</strong> · verstuurd {fmtDatum(m.verstuurd_op)}<br />
        📍 {m.locatie_adres || '—'}
        {m.locatie_lat != null && (
          <> · <a href={`https://www.google.com/maps/search/?api=1&query=${m.locatie_lat},${m.locatie_lng}`} target="_blank" rel="noreferrer">kaart</a></>
        )}
        {m.werkorder_id && <><br />🔧 <a href="#wo" onClick={e => { e.preventDefault(); navigate('/werkorder/' + m.werkorder_id); }}>{m.ordernummer || '#' + m.werkorder_id}</a> {m.werkorder_titel}</>}
        {m.project_id && <><br />📁 <a href="#pr" onClick={e => { e.preventDefault(); navigate('/projecten/' + m.project_id); }}>{m.project_naam}</a></>}
      </div>

      <div style={{ background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: 10, padding: 12, marginBottom: 14 }}>
        <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 8 }}>Koppelen</div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <input value={wo} onChange={e => setWo(e.target.value)} placeholder="Ordernummer of werkorder-id"
            style={{ ...invoer, flex: '1 1 180px' }} />
          <select value={proj} onChange={e => setProj(e.target.value)} style={{ ...invoer, flex: '1 1 200px' }}>
            <option value="">{wo ? '— project van werkorder —' : '— geen project —'}</option>
            {projecten.map(p => <option key={p.id} value={p.id}>{p.project_code ? p.project_code + ' · ' : ''}{p.naam}</option>)}
          </select>
          <button onClick={koppel} disabled={bezig} style={knopPri}>Opslaan</button>
        </div>
        {melding && <div style={{ fontSize: 13, marginTop: 8 }}>{melding}</div>}
      </div>

      <MetingInhoud inzending={m} />

      <div style={{ marginTop: 14, borderTop: '1px solid #e5e7eb', paddingTop: 12 }}>
        <textarea value={opm} onChange={e => setOpm(e.target.value)} rows={2} placeholder="Opmerking kantoor (optioneel)"
          style={{ ...invoer, width: '100%', boxSizing: 'border-box', fontFamily: 'inherit', marginBottom: 8 }} />
        {m.status === 'verwerkt' ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ fontSize: 13, color: '#166534' }}>✓ Verwerkt {fmtDatum(m.verwerkt_op)}</span>
            <button onClick={() => verwerk(false)} disabled={bezig} style={knopSec}>Terug naar nieuw</button>
          </div>
        ) : (
          <button onClick={() => verwerk(true)} disabled={bezig} style={{ ...knopPri, background: '#16a34a' }}>✓ Markeer als verwerkt</button>
        )}
      </div>
    </div>
  );
}

const paneel = { background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', padding: 18, position: 'sticky', top: 16, maxHeight: 'calc(100vh - 40px)', overflowY: 'auto' };
const leeg = { padding: 40, textAlign: 'center', color: '#9ca3af' };
const tag = { display: 'inline-block', background: '#f1f5f9', color: '#334155', borderRadius: 6, padding: '1px 7px', marginRight: 6 };
const invoer = { padding: '8px 10px', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 14, background: '#fff' };
const knopPri = { padding: '8px 16px', borderRadius: 8, border: 'none', background: '#2563eb', color: '#fff', fontWeight: 600, cursor: 'pointer' };
const knopSec = { padding: '7px 12px', borderRadius: 8, border: '1px solid #d1d5db', background: '#fff', color: '#374151', cursor: 'pointer', fontSize: 13 };
